import { components, operations } from "types/openapi";
import { api } from "./api";
import { ENDPOINTS } from "./endpoints";

type getWalletTokensOperation = operations["getTokenBalanceWithDeposits"];
export type refundTokenRequest = operations["refundToken"];
export type TokenDepositDto = components["schemas"]["TokenDepositDto"];

export type TokenDepositWithId = TokenDepositDto & { id: string };

/**
 *  получить информацию о неверно пополненных токенах
 */
export const getWalletTokens = (
  address: getWalletTokensOperation["parameters"]["path"]["address"],
  dataToSend: getWalletTokensOperation["parameters"]["query"]
): Promise<getWalletTokensOperation["responses"]["200"]["content"]["*/*"]> => {
  return api.get(ENDPOINTS.getWalletTokens(address), dataToSend);
};

/**
 *  возврат неверно пополненных токенов
 */
export const refundCustomTokens = (
  id: refundTokenRequest["parameters"]["path"]["address"],
  dataToSend: refundTokenRequest["requestBody"]["content"]["application/json"]
): Promise<refundTokenRequest["responses"]["200"]["content"]> => {
  return api.post(ENDPOINTS.refundCustomTokens(id), dataToSend);
};
